import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import theme from "../../../../theme";

const Counter = ({ target, isInView }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isInView) return; // Start only when in view

    let start = 0;
    const end = target;
    if (start === end) return;

    const duration = 2000;
    const increment = Math.ceil((end - start) / (duration / 30));

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        start = end;
        clearInterval(timer);
      }
      setCount(start);
    }, 30);

    return () => clearInterval(timer);
  }, [target, isInView]);

  return (
    <motion.span
      style={{
        fontFamily: '"Inter", sans-serif',
        fontSize: "clamp(2rem, 4vw, 3rem)",
        color: theme.colors.text.primary,
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {count.toLocaleString()}
    </motion.span>
  );
};

export default Counter;
